const schema = localStorage.getItem("schema");

export const basicFormData = () => ({
  inputData: {
    type: "",
    reason: "",
    descriptions: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "scrap_reason_masters",
    schema: schema,
    inputData: {
      type: "",
      name: "",
      descriptions: "",
      created_by: "",
      updated_by: "",
      is_active: true,
    },
    moduleWhereCondition: {
      is_active: true,
    },
  };

  const navigatePage = { back: "/scrap-reason-list" };

  const headerName = "Scrap Reason";

  const validationType = "ScrapReasonCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = (type) => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "scrap_reason_masters",
    schema: schema,
  };

  const columnData = [
    { label: "Sr. No", value: "index" },
    { label: "Reason", value: "reason" },
    { label: "Descriptions", value: "descriptions" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/scrap-reason-create",
    edit: "/scrap-reason-create",
    view: "/scrap-reason-view",
  };

  const searchfields = ["reason", "descriptions"];

  const headerName = "Scrap Reason";
  const endpoint = "/getRecords";
  const exportFileName = "ScrapReasonData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};
